const kilometersPerMile = 1.609344;

export const milesToKilometers = (miles: number) =>
  Math.round(miles * kilometersPerMile);
